<template>
    <div class="col-12 planne-link-form">
        <div class="row">
            <div class="col">
                <h1 class="pageTitle">{{ pageTitle }}</h1>
            </div>
        </div>

        <div v-if="!formType" class="row selector">
            <div class="col-12">
                <TypeSelector :onSelect="onFormSelect"></TypeSelector>
            </div>
        </div>

        <div v-else class="row">
            <div class="col-12">
                <DirectLinkForm
                    :type="formType"
                    :appCode="appCode"
                    :appId="appId"
                    :enableExtendedCalendar="enableExtendedCalendar"
                    showSaveButton
                    showBackButton
                    :onBack="()=>handleBack()"
                    :onSuccess="handleSaveSuccess"
                    :onFail="handleSaveFail"
                    :helperText="errorMessage"
                    :error="error"
                    :dashboardUrl="dashboardUrl"
                    :useDashboardSeatMap="useDashboardSeatMap"
                />
            </div>
        </div>

        <div class="row" v-if="!formType">
            <div class="col-md-2 offset-md-5 text-center">
                <Button :onClick="() => back()" primary>Voltar</Button>
            </div>
        </div>
    </div>
</template>

<script>
import { getQueryParam } from '../../helpers';
import TypeSelector from './components/TypeSelector';
import DirectLinkForm from './components/DirectLinkForm';
import Button from '../Button';

export default {
    components: { TypeSelector, DirectLinkForm, Button },
    props: {
        appCode: String,
        appId: String,
        type: {
            type: String,
            required: false,
            default: null
        },
        dashboardUrl: {
            type: String,
            required: true,
        },
        useDashboardSeatMap: {
            type: Boolean,
            required: true,
        },
        enableExtendedCalendar: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    data(){
        return {
            formType: this.type,
            error: false,
            errorMessage: null
        };
    },
    computed: {
        pageTitle() {
            if (this.formType === 'cart') {
                return 'Novo link de carrinho'
            }

            if (this.formType === 'payment') {
                return 'Novo link de pagamento'
            }

            return 'Novo link'
        }
    },
    methods: {
        back() {
            window.history.go(-1);
        },
        handleBack() {
            if (this.type) {
                window.history.go(-1);
            } else {
                this.formType = null
            }
        },
        onFormSelect(type) {
            this.formType = type
        },
        handleSaveSuccess(data){
            const token = getQueryParam('token')
            window.location = data.directLikePage + (token ? `?token=${token}` : '')
        },
        handleSaveFail(err){
            this.error = true
            this.errorMessage = Object.keys(err.errors).map(
                key => err.errors[key].join(' ')
            ).join('<br />')
        }
    },
    mounted() {
    }
}
</script>

<style scoped lang="scss">
.pageTitle {
    margin-bottom: 20px;
}

.selector {
    margin-bottom: 20px;
}
</style>
